import { useEffect, useState } from "react";
import { Form, Button, Container, Row, Col, Alert } from "react-bootstrap";
import "./new-password-page-styles.css";
import { useNavigate } from "react-router-dom";

import Loading from "../SpinnerAndError/Loading";

const RequestNewPasswordPage = () => {
  const [email, setEmail] = useState();
  const [emailNotFoundInDatabase, setEmailNotFoundInDatabase] = useState(false);
  const [pleaseCheckYourEmail, setPleaseCheckYourEmail] = useState(false);
  const [somethingWentWrong, setSomethingWentWrong] = useState(false);
  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();

  const onSubmitFunction = (event) => {
    event.preventDefault();
    setLoading(true);
    generateNewPasswordFunction();
  };

  const bodyData = {
    email: email,
  };

  let generateNewPasswordFunction = async () => {
    const response = await fetch(process.env.REACT_APP_NEW_PASSWORD_REQUEST, {
      method: "POST",
      headers: {
        "Content-type": "application/json",
      },
      body: JSON.stringify(bodyData),
    });
    if (response.status === 201) {
      console.log("Response", response);
      const data = await response.json();
      console.log(data);
      setPleaseCheckYourEmail(true);

      setTimeout(() => {
        navigate("/generate-new-password");
      }, "5000");
      setLoading(false);
    } else if (response.status === 404) {
      console.log("Response", response);
      console.log("Email not found in database.");
      setEmailNotFoundInDatabase(true);
      setLoading(false);
    } else {
      console.log("Something went wrong.");
      setSomethingWentWrong(true);
    }
  };

  return (
    <>
      <div className="outer-wrapper-top-div">
        <Container fluid>
          <Row>
            <Col xs={12} align="center" className="mt-5 mb-5">
              <div>
                <div className="alert-messages-login-page">
                  {pleaseCheckYourEmail && (
                    <Alert variant="success">Please check your inbox. 📬</Alert>
                  )}
                  {emailNotFoundInDatabase && (
                    <Alert variant="warning" style={{ paddingBottom: "0" }}>
                      <p>
                        Email not found in our database. Please{" "}
                        <span>
                          <a style={{ fontWeight: "500" }} href="/signup">
                            {" "}
                            Sign Up.
                          </a>
                        </span>
                      </p>
                    </Alert>
                  )}
                  {somethingWentWrong && (
                    <Alert variant="danger">
                      Something went wrong. Please contact us on
                      contact@serpmaze.com
                    </Alert>
                  )}
                </div>

                <div
                  style={{ background: "white" }}
                  className="login-page-outer-box-for-new-password-box"
                >
                  <div className="login-page-inner-box">
                    <Form onSubmit={onSubmitFunction}>
                      <Form.Group controlId="formBasicEmail" className="mt=4">
                        <Form.Label className="login-page-form-labels">
                          Email
                        </Form.Label>
                        <Form.Control
                          className="login-page-input-fields"
                          required
                          type="email"
                          onChange={(event) => {
                            setEmail(event.target.value);
                          }}
                        />
                      </Form.Group>
                      {loading === false ? (
                        <Button
                          variant="success"
                          type="submit"
                          size="lg"
                          className="login-page-button"
                        >
                          <span className="login-page-button-text">
                            Generate New Password
                          </span>
                        </Button>
                      ) : (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <Loading></Loading>
                        </div>
                      )}
                    </Form>
                    <p className="login-page-dont-have-an-account-text">
                      Don't have an account?{" "}
                      <span
                        style={{ paddingLeft: "0.3em" }}
                        id="login-page-dont-have-an-account-text-span"
                      >
                        {" "}
                        <a
                          className=" text-indigo-600 hover:text-indigo-500"
                          href="/signup"
                        >
                          Sign Up
                        </a>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default RequestNewPasswordPage;
